import React, { useState, useEffect } from 'react';
import produce from 'immer';
import { connect } from 'react-redux';
import { Button } from '../../base';
import * as StyledRoomCountFilter from './roomCountFilter.styles';
import { indexArray } from '../../../helpers/arrayHelpers/arrayHelpers';
import { setRoomCountFilters } from '../../../actions/filtersActions';

const RoomCountFilter = ({
	filtersReducer,
	dispatch
}) => {
	const { roomCount, selectedRoomCount } = filtersReducer;
	const indexedValues = indexArray(roomCount, 'id');
	const [selected, setSelected] = useState({});

	useEffect(() => {
		const ixSelected = indexArray(selectedRoomCount, 'id');
		setSelected(ixSelected);
	}, [selectedRoomCount]);

	const onFilterClick = (id) => {
		const newFilters = produce(selected, (draft) => {
			if(draft[id]) delete draft[id];
			else draft[id] = indexedValues[id];
		});

		dispatch(setRoomCountFilters(Object.values(newFilters)));
	};

	return (
		<StyledRoomCountFilter.Wrapper>
			<Button style={{ pointerEvents: 'none' }}>Herbergi</Button>
			{
				roomCount.map(count => (
					<Button
						key={count.id}
						tertiary={!!selected[count.id]}
						onClick={onFilterClick.bind(0, count.id)}>
						<span>{count.id}</span>
					</Button>
				))
			}
		</StyledRoomCountFilter.Wrapper>
	);
};

const mapStateToProps = ({ filtersReducer }) => ({
	filtersReducer
});

export default connect(mapStateToProps)(RoomCountFilter);
